import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * Etichette del paginatore in italiano.
 *
 * Material le fornisce solo in inglese: in fondo a ogni elenco del pannello si
 * leggeva "Items per page: 25" e "0 of 0", in mezzo a un'interfaccia per il
 * resto tutta italiana.
 */
export function paginatoreItaliano(): MatPaginatorIntl {
  const intl = new MatPaginatorIntl();

  intl.itemsPerPageLabel = 'Elementi per pagina:';
  intl.nextPageLabel = 'Pagina successiva';
  intl.previousPageLabel = 'Pagina precedente';
  intl.firstPageLabel = 'Prima pagina';
  intl.lastPageLabel = 'Ultima pagina';

  intl.getRangeLabel = (pagina: number, perPagina: number, totale: number): string => {
    if (totale === 0) return 'Nessun elemento';

    const primo = pagina * perPagina;
    // Con un totale non attendibile l'ultimo indice puo' superare il totale.
    const ultimo = Math.min(primo + perPagina, totale);
    // Il separatore delle migliaia: con dodicimila articoli "12408" si legge male.
    const cifre = (n: number) => n.toLocaleString('it-IT');

    return `${cifre(primo + 1)} – ${cifre(ultimo)} di ${cifre(totale)}`;
  };

  return intl;
}
